// extracted by mini-css-extract-plugin
module.exports = {"title3":"style__title3__la2CE","title4":"style__title4__Zvioy","block":"style__block__W5va4"};